module.exports = __webpack_public_path__ + "img/high-school-volunteer-detail.67ee803e.png";